import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import type * as React from 'react';
import UserMenu from '@/components/UserMenu';

type Props = {
    open ?: boolean;
    handleDrawerOpen ?: () => void;
};

const CapacityNavBar = ({open, handleDrawerOpen} : Props) : React.ReactElement => {
    return <AppBar position="fixed">
        <Toolbar>
            {open !== undefined && handleDrawerOpen && <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{mr: 2, ...(open && {display: 'none'})}}
            >
                <MenuIcon/>
            </IconButton>}
            <Typography variant="h6" noWrap component="div" sx={{flexGrow: 1}}>
                Capacity Planner
            </Typography>
            <UserMenu/>
        </Toolbar>
    </AppBar>;
};

export default CapacityNavBar;
